module.exports = __webpack_public_path__ + "img/BNB.54ca7234.png";